// extracted by mini-css-extract-plugin
module.exports = {"dialog":"V7akgroEIAuB8Gq5E_W5C","btn-back":"_1r53-rBUE_ygIYzB6KNkNk","pageNotFound":"_17TbJNbHnFIgdLOj9W-Er8","textNotFound":"_2fvdH8h0qwGt5_1ixc9NMk"};